import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AppPaths from '../../../../../AppPaths';
import styles from './RecallBanner.module.scss';

/** Notice bar at the top of the supplements PDP pointing at the (English-only) recall notice. */
export default function RecallBanner() {
  const { t } = useTranslation();

  return (
    <div role="region" aria-label={t('recall_notice')} className={styles.banner}>
      <div className={styles.inner}>
        <strong>{t('recall_notice_colon')}</strong> {t('supplements_recall_banner')}{' '}
        <Link to={AppPaths.SupplementsRecall} className={styles.link}>
          {t('learn_more')}
        </Link>
      </div>
    </div>
  );
}
